import httpUtility from '../../utils/http.utility.js'

import apiClient from '../client.js'

async function getTicketgroup(id) {
  const response = await apiClient.get(`/ticket-group/${id}`)
  return response.data.ticketGroup
}

async function getTicketgroups() {
  const response = await apiClient.get('/ticket-group')
  return response.data.ticketGroups
}

async function getTicketgroupSettings(id) {
  const response = await apiClient.get(`/ticket-group/${id}/settings`)
  return response.data.settings
}

async function getTicketGroupUsers(search = '', { groupId, page, pageSize, signal } = {}) {
  const response = await apiClient.get(`/ticket-group/${encodeURIComponent(groupId)}/search-users?${httpUtility.search({ search, page, pageSize })}`, { signal })
  return { items: response.data.items, total: response.data.total }
}

async function createTicketgroup(payload) {
  return apiClient.post('/ticket-group', payload)
}

async function updateTicketgroup(id, patch) {
  return apiClient.patch(`/ticket-group/${id}`, patch)
}

async function deleteTicketgroup(id) {
  return apiClient.delete(`/ticket-group/${id}`)
}

class TicketGroupService {
  get = {
    /**
     * Load one ticket group by id.
     *
     * @param {string} id
     * @returns {Promise<object>} Unwrapped from `response.data.ticketGroup`.
     */
    async one(id) {
      return getTicketgroup(id)
    },

    /**
     * Load every ticket group visible to the caller.
     *
     * @returns {Promise<object[]>} Unwrapped from `response.data.ticketGroups`.
     */
    async all() {
      return getTicketgroups()
    },

    /**
     * Load ticket settings for one group scope.
     *
     * @param {string} id
     * @returns {Promise<object>} Unwrapped from `response.data.settings`.
     */
    async settings(id) {
      return getTicketgroupSettings(id)
    },

    /**
     * Paginated search of users attached to a ticket group.
     *
     * @param {string} [search='']
     * @param {object} params
     * @param {string} params.groupId
     * @param {number} [params.page]
     * @param {number} [params.pageSize]
     * @param {AbortSignal} [params.signal]
     * @returns {Promise<{ items: object[], total: number }>} Unwrapped from `response.data`.
     */
    async users(search = '', { groupId, page, pageSize, signal } = {}) {
      return getTicketGroupUsers(search, { groupId, page, pageSize, signal })
    },
  }

  create = {
    /**
     * Create a ticket group.
     *
     * @param {object} payload
     * @returns {Promise<import('axios').AxiosResponse>}
     */
    async ticketgroup(payload) {
      return createTicketgroup(payload)
    },
  }

  update = {
    /**
     * Update one ticket group.
     *
     * @param {string} id
     * @param {object} patch
     * @returns {Promise<import('axios').AxiosResponse>}
     */
    async ticketgroup(id, patch) {
      return updateTicketgroup(id, patch)
    },
  }

  delete = {
    /**
     * Delete one ticket group.
     *
     * @param {string} id
     * @returns {Promise<import('axios').AxiosResponse>}
     */
    async ticketgroup(id) {
      return deleteTicketgroup(id)
    },
  }
}

export default new TicketGroupService()
